import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SAVED_CART_MANAGER_NAME = 'SavedCartManager';
export const SAVED_CART_MANAGER_SLOTS: Array<keyof SavedCartManagerClasses> = [
	'root',
	'inputWrapper',
] as const;

export type SavedCartManagerSlot = (typeof SAVED_CART_MANAGER_SLOTS)[number];

export interface SavedCartManagerClasses {
	root: string;
	inputWrapper: string;
}

export type SavedCartManagerClassKey = keyof SavedCartManagerClasses;

export const getSavedCartManagerUtilityClass = (slot: string) =>
	generateUtilityClass(SAVED_CART_MANAGER_NAME, slot as SavedCartManagerSlot);

export const savedCartManagerClasses: SavedCartManagerClasses =
	generateUtilityClasses(SAVED_CART_MANAGER_NAME, ['root', 'inputWrapper']);

export default savedCartManagerClasses;
